import type { ProjectType } from '@services/dto/projectShare';

import type {
  BudgetRange,
  BuildingCategory,
  ConstructionCategory,
  ConstructionType,
  DeliveryMethod,
  EstimateType,
  PhaseType,
  ProcurementMethod,
} from '@services/dto/projectSupport';

export type ProjectSupportState = {
  constructionCategories: ConstructionCategory[];
  constructionTypes: ConstructionType[];
  phaseTypes: PhaseType[];
  procurementMethods: ProcurementMethod[];
  deliveryMethods: DeliveryMethod[];
  budgetRanges: BudgetRange[];
  buildingCategories: BuildingCategory[];
  projectTypes: ProjectType[];
  estimateTypes: EstimateType[];
  language?: string;
  loading: boolean;
  // biome-ignore lint/suspicious/noExplicitAny: Loose type.
  error?: any;
};
